import React from 'react';
import { Input, Button, FormFeedback } from 'reactstrap';

const TopicAreaConfigRow = ({
    index,
    validation,
    topicAreas,
    onRemove,
    onAdd,
    isFirstRow
}) => {
    return (
        <div className="row g-3 mt-1 mb-3 align-items-center">
            <div className="col-xxl-1">
                <div className="ms-3">
                    <label htmlFor="firstName"
                        className="form-label ">{index + 1}. </label>
                </div>
            </div>
            <div className="col-xxl-4">
                <Input
                    name={`topic_area_configs[${index}].topic_area_id`}
                    type="select"
                    className="form-select"
                    id={`topic-area-${index}`}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.topic_area_configs?.[index]?.topic_area_id || ""}
                    invalid={
                        validation.touched.topic_area_configs?.[index]?.topic_area_id &&
                            validation.errors.topic_area_configs?.[index]?.topic_area_id
                            ? true
                            : false
                    }
                >
                    <React.Fragment>
                        <option value="">Select Topic Area</option>
                        {topicAreas.map((item, key) => (
                            <option value={item.id} key={key}  >{item.topic_area_translation[0].full_name}</option>
                        ))}
                    </React.Fragment>
                </Input>
                {validation.touched.topic_area_configs?.[index]?.topic_area_id &&
                    validation.errors.topic_area_configs?.[index]?.topic_area_id && (
                        <FormFeedback type="invalid">
                            {validation.errors.topic_area_configs?.[index]?.topic_area_id}
                        </FormFeedback>
                    )}
            </div>
            <div className="col-xxl-4">
                <Input
                    name={`topic_area_configs[${index}].no_question_require`}
                    type="text"
                    id={`no-question-require-${index}`}
                    placeholder="Enter Questions like 0,1,2..."
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.topic_area_configs?.[index]?.no_question_require || ""}
                    invalid={
                        validation.touched.topic_area_configs?.[index]?.no_question_require &&
                            validation.errors.topic_area_configs?.[index]?.no_question_require
                            ? true
                            : false
                    }
                />
                {validation.touched.topic_area_configs?.[index]?.no_question_require &&
                    validation.errors.topic_area_configs?.[index]?.no_question_require && (
                        <FormFeedback type="invalid">
                            {validation.errors.topic_area_configs?.[index]?.no_question_require}
                        </FormFeedback>
                    )}
            </div>
            <div className="col-xxl-3">
                    <Button
                        type="button"
                        className="btn btn-danger"
                        onClick={onRemove}
                    >
                        <i className="ri-delete-bin-line align-bottom me-1"></i> Remove
                    </Button>
            </div>
        </div>
    );
};

export default TopicAreaConfigRow;